'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactIntl = require('react-intl');

var _IsomorphicCSSProvider = require('helpers/IsomorphicCSSProvider');

var _IsomorphicCSSProvider2 = _interopRequireDefault(_IsomorphicCSSProvider);

var _useStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _objectFitImages = require('object-fit-images');

var _objectFitImages2 = _interopRequireDefault(_objectFitImages);

var _firebase = require('firebase');

var firebase = _interopRequireWildcard(_firebase);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

require('normalize.css');

require('./theme/global.scss');

require('slick-carousel/slick/slick.css');

require('react-tagsinput/react-tagsinput.css');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _en = require('react-intl/locale-data/en');

var _en2 = _interopRequireDefault(_en);

var _th = require('react-intl/locale-data/th');

var _th2 = _interopRequireDefault(_th);

var _zh = require('react-intl/locale-data/zh');

var _zh2 = _interopRequireDefault(_zh);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */

firebase.initializeApp(_config2.default.firebase);
// import io from 'socket.io-client';

window.firebase = firebase;
var messaging = firebase.messaging();

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js');
  navigator.serviceWorker.ready.then(function (registration) {
    return messaging.useServiceWorker(registration);
  });
}

(0, _reactIntl.addLocaleData)([].concat((0, _toConsumableArray3.default)(_en2.default), (0, _toConsumableArray3.default)(_th2.default), (0, _toConsumableArray3.default)(_zh2.default)));

var client = new _ApiClient2.default();
// const history = useScroll(() => browserHistory)();
var _browserHistory = (0, _useStandardScroll2.default)(function () {
  return _reactRouter.browserHistory;
})();
var dest = document.getElementById('content');
// const store = createStore(history, client, window.__data);
var store = (0, _create2.default)(_browserHistory, client, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);

// function initSocket() {
//   const socket = io('', {path: '/ws'});
//   socket.on('news', (data) => {
//     console.log(data);
//     socket.emit('my other event', { my: 'data from client' });
//   });
//   socket.on('msg', (data) => {
//     console.log(data);
//   });

//   return socket;
// }
(0, _objectFitImages2.default)('img.img-object-fit', { watchMQ: true });
var css = new _set2.default();
var context = { insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    return styles.forEach(function (style) {
      return css.add(style._style);
    });
  } };
// global.socket = initSocket();
var routes = (0, _routes2.default)(store);
var component = _react2.default.createElement(
  _reactRouter.Router,
  { render: function render(props) {
      return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
          return !item.deferred;
        }, context: context }));
    }, history: history },
  routes
);

var localeProps = store.getState().language;
var locale = localeProps.locale;
if (locale === 'zh') {
  locale = 'zh-cn';
}
_momentTimezone2.default.locale(locale);

(0, _reactRouter.match)({ history: history, routes: routes }, function () {
  _reactDom2.default.render(_react2.default.createElement(
    _IsomorphicCSSProvider2.default,
    { context: context },
    _react2.default.createElement(
      _reactRedux.Provider,
      { store: store, key: 'provider' },
      _react2.default.createElement(
        _reactIntl.IntlProvider,
        localeProps,
        component
      )
    )
  ), dest);

  if (process.env.NODE_ENV !== 'production') {
    window.React = _react2.default; // enable debugger

    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
      console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
    }
  }

  if (false && __DEVTOOLS__ && !window.devToolsExtension) {
    var DevTools = require('./containers/DevTools/DevTools');
    _reactDom2.default.render(_react2.default.createElement(
      _reactRedux.Provider,
      { store: store, key: 'provider' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(DevTools, null)
      )
    ), dest);
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1473
// module chunks = 47